import { ispApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';

export const getCountryCodes = (companyId: string, config: AxiosRequestConfig = {}) =>
  ispApi.get<string[]>(`/isp-internal/api/v1/companies/${companyId}/admin-contacts/country-codes`, config);
